module.exports = __webpack_public_path__ + "img/3.29857aa1.png";